//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import PaymentForm from '@/views/billing/payment/PaymentForm'
import PaymentAmount from '@/views/billing/payment/PaymentAmount'
import PaymentMethodSelected from '@/views/billing/payment/PaymentMethodSelected'

export default {
  components: {
    PaymentMethodSelected,
    PaymentAmount,
    PaymentForm
  },

  data() {
    return {}
  }
}
